import {
  type BaseNavItem,
  type SecondLevelNavItem,
  type ThirdLevelNavItem } from
'~/interfaces/HeaderFooterNavV2';

import { PrimaryHeaderNavGroup } from '../PrimaryHeaderNavGroup';
import { SecondaryHeaderNavGroup } from '../SecondaryHeaderNavGroup';
import { TertiaryHeaderNavGroup } from '../TertiaryHeaderNavGroup';

import styles from './HeaderDesktop.module.css';

interface DesktopNavData {
  firstLevelNav: BaseNavItem[];
  secondLevelNav: SecondLevelNavItem[];
  thirdLevelNav: ThirdLevelNavItem[];
}

interface HeaderDesktopProps {
  desktopNavData: DesktopNavData;
  resourcesUrl: string;
}

type THeaderDesktop = React.FunctionComponent<HeaderDesktopProps>;

export const HeaderDesktop: THeaderDesktop = ({
  desktopNavData,
  resourcesUrl
}) => {
  const { firstLevelNav, secondLevelNav, thirdLevelNav } = desktopNavData;

  return (
    <header className={styles.headerContainer} data-testid="header-desktop-v2">
			<PrimaryHeaderNavGroup links={firstLevelNav} />
			<SecondaryHeaderNavGroup
        links={secondLevelNav}
        resourcesUrl={resourcesUrl} />

			<TertiaryHeaderNavGroup links={thirdLevelNav} />
		</header>);

};